import React from "react";
import { TextField } from "@mui/material";

/**
 * Shared form text field with consistent outlined/small styling.
 * Label floats only on focus or when the field has a value.
 * Pair with form `noValidate` so only app validation messages are shown.
 */
const FormField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error = false,
  helperText = "",
  required = false,
  fullWidth = true,
  size = "small",
  type = "text",
  autoFocus = false,
  disabled = false,
  multiline = false,
  rows,
  InputLabelProps,
  sx,
  ...rest
}) => {
  return (
    <TextField
      label={label}
      name={name}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
      size={size}
      type={type}
      autoFocus={autoFocus}
      disabled={disabled}
      multiline={multiline}
      rows={rows}
      variant="outlined"
      InputLabelProps={InputLabelProps}
      sx={sx}
      {...rest}
    />
  );
};

export default FormField;
